import React, { Component } from 'react'
// eslint-disable-next-line
import { Link, Navigate, Route, Routes, useSearchParams } from 'react-router-dom'

import { connect } from "react-redux"
import { increment, decrement } from "../features/counter/counterSlice"
import { setLoggedIn } from "../features/account/loginSlice"
import { setAccount } from "../features/account/accountSlice"
import { setCompany } from "../features/account/companySlice"

import axios from "axios";
// eslint-disable-next-line
import qs from 'qs';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";

import { hidePreloader, showPreloader } from '../library/helper';
import { withTranslation } from 'react-i18next';

import InputNumeric from '../components/InputNumeric'

export class Setting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectSetting: false,

            selectedIndustry: 0,
            selectedEmployees: 0,
            selectedStandard: 0,
            selectedBaseline: 0,
            selectedGoal: 0,
            selectedBoundary: 0,

            countTargetRecords: 1,
            countBAURecords: 1,

            selectedScenario: 1,

            listGoalRecord: [
                {
                    year: "",
                    value: "",
                    note: "",
                }
            ],

            listGoalBau: [
                {
                    year: "",
                    value: "",
                    note: "",
                }
            ],
        }
    }

    componentDidMount = async () => {
        showPreloader();

        console.log("company");
        // eslint-disable-next-line
        const data = {}

        const optionsGetBoundaries = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/client/boundary`
        };
        let listBoundary = [];
        const responseGetBoundaries = await axios(optionsGetBoundaries);
        if (responseGetBoundaries.data.success) {
            listBoundary = responseGetBoundaries.data.data
        }

        const optionsClientIndustry = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/client/industry`
        };
        const responseClientIndustry = await axios(optionsClientIndustry);
        let listIndustry = [];
        if (responseClientIndustry.data.success) {
            listIndustry = responseClientIndustry.data.data;
        }
        console.log(listIndustry)

        const optionsGetSetting = {
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url: `${process.env.REACT_APP_BASE_SERVER}/account/setting/read`
        };
        const responseGetSetting = await axios(optionsGetSetting);
        let setting = [];
        if (responseGetSetting.data.success) {
            setting = responseGetSetting.data.data[0]
        }
        console.log(setting)

        this.setState({
            listIndustry: listIndustry,
            listBoundary: listBoundary,
            selectedIndustry: setting.client_industry,
            selectedEmployees: setting.client_employees,
            selectedStandard: setting.client_standard,
            selectedBoundary: setting.client_boundary,
            selectedBaseline: new Date(setting.client_baseline, 0),
            selectedGoal: setting.client_goal,
            selectedScenario: setting.client_scenario,
            selectedGwp: setting.client_gwp || 'ar5',
        })

        hidePreloader();
    }

    onSelectIndustry = async (e) => {
        let companyIndustry = e.target.value;
        this.setState({
            selectedIndustry: companyIndustry
        })
    }

    onSelectStandard = async (e) => {
        let companyStandard = e.target.value;
        this.setState({
            selectedStandard: companyStandard
        })
    }

    onSelectBoundary = async (e) => {
        let companyBoundaryApproach = e.target.value;
        this.setState({
            selectedBoundary: companyBoundaryApproach
        })
    }

    onSelectGoal = async (e) => {
        let companyGoal = e.target.value;
        this.setState({
            selectedGoal: companyGoal
        })
    }

    onSelectGwp = async (e) => {
        this.setState({
            selectedGwp: e.target.value,
        })
    }

    onSaveRecordCall = async (data) => {
        const options = {
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url: `${process.env.REACT_APP_BASE_SERVER}/account/setting/update`
        };
        const response = await axios(options);
        if (response.data.success) {
            return true;
        } else {
            return false;
        }
    }

    onSaveSetting = async () => {
        let invalidData = false;

        let industry = this.state.selectedIndustry;
        let employees = this.state.selectedEmployees;
        let standard = this.state.selectedStandard;

        // eslint-disable-next-line
        if (industry > 0 && employees > 0 && standard > 0) {

            const data = {
                'industry': this.state.selectedIndustry,
                'employee': this.state.selectedEmployees,
                'standard': this.state.selectedStandard,
                'boundary': this.state.selectedBoundary,
                'baseline': new Date(this.state.selectedBaseline).getFullYear(),
                'goal': this.state.selectedGoal,
                gwp: this.state.selectedGwp,
            };

            const result = this.onSaveRecordCall(data);
            if (result) {
                invalidData = false;
            }
            console.log("success")
        } else {
            invalidData = true;
            console.log("failed")
        }
        if (invalidData) {
            Swal.fire({
                title: '',
                html: '<p>Please fill all information needs</p>',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            })
        } else {
            Swal.fire({
                title: '',
                html: '<p>Successfully update settings</p>',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            })
        }
    }

    onInputEmployee = (values, sourceInfo) => {
        if (sourceInfo?.event?.target?.name && values) {
            this.setState({
                selectedEmployees: values.value,
            })
        }
    }

    onSelectDate = async (e) => {
        var datePick = new Date(new Date(e).getFullYear(), 1, 7);
        console.log(datePick)
        this.setState({
            selectedBaseline: datePick,
        })
    }

    onSelectScenario = async (e) => {
        let scenario = e.target.value;
        this.setState({
            selectedScenario: scenario
        })
    }

    onUpdateScenario = async () => {
        console.log(this.state.selectedScenario)
    }

    onInsertGoalTarget = async () => {
        let data = this.state.listGoalRecord;
        data.push({
            year: "",
            value: "",
            note: "",
        })
        this.setState({
            countTargetRecords: this.state.countTargetRecords + 1,
        })
    }

    onInsertGoalBau = async () => {
        let data = this.state.listGoalBau;
        data.push({
            year: "",
            value: "",
            note: "",
        })
        this.setState({
            countBAURecords: this.state.countBAURecords + 1,
        })
    }

    onDeleteGoalTarget = async (index) => {
        let data = this.state.listGoalRecord;
        data.splice(index, 1)
        this.setState({
            countTargetRecords: this.state.countTargetRecords - 1,
        })
    }

    onDeleteGoalBau = async (index) => {
        let data = this.state.listGoalBau;
        data.splice(index, 1)
        this.setState({
            countBAURecords: this.state.countBAURecords - 1,
        })
    }

    render() {
        const { redirectSetting, listIndustry } = this.state;

        if (redirectSetting) {
            return <Navigate to={'/setting'} />
        }

        let optionIndustry = [];
        // eslint-disable-next-line
        if (listIndustry != undefined) {
            if (listIndustry.length > 0) {
                listIndustry.map(async (item, index) => {
                    optionIndustry.push(<option key={index + 1} value={item.industry_id}>{item.industry_name}</option>)
                })
            }
        }

        let optionBoundary = [];
        // eslint-disable-next-line
        if (this.state.listBoundary != undefined) {
            if (this.state.listBoundary.length > 0) {
                this.state.listBoundary.map(async (item, index) => {
                    optionBoundary.push(<option key={index + 1} value={item.boundary_id}>{item.boundary_name}</option>)
                })
            }
        }

        let targetGoal = [];
        for (let i = 0; i < this.state.countTargetRecords; i++) {
            targetGoal.push(
                <tr key={i}>
                    <td>
                        <DatePicker
                            id="date"
                            selected={this.state.selectedBaseline}
                            onChange={(date) => this.onSelectDate(date)}
                            dateFormat="yyyy"
                            className="form-select w-remove"
                            showYearPicker
                        />
                    </td>
                    <td>
                        <div className="d-flex gap-2">
                            <input
                                onChange={e => this.onInputAsset(e, i)}
                                className="form-control"
                                placeholder="percentage (%)"
                            />
                        </div>
                    </td>
                    <td>
                        <input
                            value={""}
                            onChange={() => this.onDeleteRow(i)}
                            className="form-control"
                            placeholder="note"
                        ></input>
                    </td>
                    <td>
                        <button onClick={() => this.onDeleteGoalTarget(i)} type="button" className="btn btn-icon btn-ghost-danger"><i className="ri-delete-bin-5-line"></i></button>
                    </td>
                </tr>
            )
        }

        let targetBau = [];
        for (let i = 0; i < this.state.countBAURecords; i++) {
            targetBau.push(
                <tr key={i}>
                    <td>
                        <DatePicker
                            id="date"
                            selected={this.state.selectedBaseline}
                            onChange={(date) => this.onSelectDate(date)}
                            dateFormat="yyyy"
                            className="form-select w-remove"
                            showYearPicker
                        />
                    </td>
                    <td>
                        <div className="d-flex gap-2">
                            <input
                                onChange={e => this.onInputAsset(e, i)}
                                className="form-control"
                                placeholder="percentage (%)"
                            />
                        </div>
                    </td>
                    <td>
                        <input
                            value={""}
                            onChange={() => this.onDeleteRow(i)}
                            className="form-control"
                            placeholder="note"
                        ></input>
                    </td>
                    <td>
                        <button onClick={() => this.onDeleteGoalBau(i)} type="button" className="btn btn-icon btn-ghost-danger"><i className="ri-delete-bin-5-line"></i></button>
                    </td>
                </tr>
            )
        }

        return (
            <div className="page-content">
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">{this.props.t('menu.label6')}</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <ul className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                                        <li className="nav-item">
                                            <a className="nav-link active" data-bs-toggle="tab" href="#personalDetails" role="tab">
                                                <i className="fas fa-home"></i> {this.props.t('menu.label63')}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="card-body p-4">
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="personalDetails" role="tabpanel">
                                            <form action="#">
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="lastnameInput" className="form-label">Industry</label>
                                                            <select onChange={e => this.onSelectIndustry(e)} value={this.state.selectedIndustry} className="form-select mb-3" id="companyIndustry">
                                                                {optionIndustry}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="lastnameInput" className="form-label">Boundaries Approach</label>
                                                            <select onChange={e => this.onSelectBoundary(e)} value={this.state.selectedBoundary} className="form-select mb-3" id="companyBoundary">
                                                                {optionBoundary}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="mb-3">
                                                            <label
                                                                htmlFor="numberOfEmployees"
                                                                className="form-label"
                                                            >
                                                                Number of Employees
                                                            </label>
                                                            <InputNumeric
                                                                id="numberOfEmployees"
                                                                name="numberOfEmployees"
                                                                isAllowed={(values) => {
                                                                    if (!values.value) return true
                                                                    const { floatValue } = values
                                                                    return floatValue > 0
                                                                }}
                                                                value={this.state.selectedEmployees}
                                                                onValueChange={this.onInputEmployee}
                                                                placeholder={this.props.t('emission.form.enter')}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/*<div className="col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="phonenumberInput" className="form-label">Standard</label>
                                                            <select className="form-select mb-3" id="companyStandard" value={this.state.selectedStandard} onChange={e => this.onSelectStandard(e)} >
                                                                <option value="1">GHG Protocol</option>
                                                                <option value="2">ISO 14064-1</option>
                                                                <option value="3">GRI 305</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="firstnameInput" className="form-label">Baseline Year</label>
                                                            <DatePicker
                                                                id="date"
                                                                selected={this.state.selectedBaseline}
                                                                onChange={(date) => this.onSelectDate(date)}
                                                                dateFormat="yyyy"
                                                                className="form-select mb-3"
                                                                showYearPicker
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="phonenumberInput" className="form-label">Goal</label>
                                                            <select className="form-select mb-3" id="companyGoal" value={this.state.selectedGoal} onChange={e => this.onSelectGoal(e)} >
                                                                <option value="1">Net-zero</option>
                                                                <option value="2">Carbon Neutral</option>
                                                            </select>
                                                        </div>
                                                    </div>*/}
                                                    <div className="col-lg-12">
                                                        <div className="hstack gap-2 justify-content-end">
                                                            <button type="button" className="btn btn-primary" onClick={() => this.onSaveSetting()}>{this.props.t('general.btnUpdate')}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    count: state.counter.value,
    loggedIn: state.loggedIn.value,
    account: state.account.value,
    company: state.company.value,
});

const mapDispatchToProps = { increment, decrement, setLoggedIn, setAccount, setCompany };

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Setting));
